import type { ReactNode } from 'react';
import type {
  PhotoView,
  VideoConfig,
  GalleryUsageData,
} from '../../../../../types';
import { useAdDetailsContext } from '../../../../../contexts/AdDetailsContext';
import { useConvertContext } from '../../../../../contexts/ConvertContext';
import { GalleryOnPage } from '../../../../../components/Toolkit/Gallery/GalleryOnPage';
import { PAGE } from '../../../../../helpers/pages';
import { pushToDataLayer } from '../../../../../services/gtmService';

export interface RevealGalleryProps {
  photo?: PhotoView;
  photos?: PhotoView[];
  link360?: string;
  link360Interior?: string;
  videoConfig?: VideoConfig;
  title: string;
  renderSendMessage?: ReactNode;
  renderShowPhone?: ReactNode;
  renderShareAd?: ReactNode;
  renderSaveAd?: ReactNode;
  keyInfo?: (string | undefined | ReactNode)[];
  mediaCount: number;
  renderDfpUnit?: ReactNode;
  youTubeVideoId?: string;
  youTubeReviewVideoId?: string;
  isDealer: boolean;
  trackingId?: string;
  className?: string;
  isYoutubeReviewOpen?: boolean;
  setIsYoutubeReviewOpen?: (value: boolean) => void;
  cdnUrl: string;
  isPreview?: boolean;
  refreshTopAndSideDFPUnit?: () => void;
}

function RevealGallery({ ...rest }: RevealGalleryProps) {
  const { isSendMessageModalOpen } = useAdDetailsContext();
  const { galleryInteractionsVariationKey } = useConvertContext({
    page: PAGE.AD_DETAILS,
  });

  function trackGalleryUsage(usageEvent: GalleryUsageData) {
    const { event, data } = usageEvent;

    if (event === 'CLOSE') {
      pushToDataLayer({
        event: 'gallery_close',
        ...data,
      });
    }

    if (event === 'OPEN') {
      pushToDataLayer({ event: 'lightbox_open' });
    }
  }

  return (
    <GalleryOnPage
      reportOnGalleryUsage={trackGalleryUsage}
      disableKeyEventListeners={isSendMessageModalOpen}
      galleryInteractionsVariant={galleryInteractionsVariationKey}
      {...rest}
    />
  );
}

export { RevealGallery };
